/*global google*/
import React, { Component } from 'react';
import { Form, Button, Item, Segment, Label } from 'semantic-ui-react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import styles from './house.scss';
import "react-datepicker/dist/react-datepicker.css";
import queryString from 'query-string'
import { Link } from "react-router-dom";
import Detail from '../detail/detail.jsx'
import history from "../../history"

const mapStyle = {
  width: '40%',
  height: '100%'
};


//import { MovieList as MovieListCss, MovieListHeader, Container } from './MovieList.module.scss'
class House extends Component {
  constructor() {
    super();
    this.state = {
      houses: [],
      places: [],
      center: { lat: 0, lng: 0 },
      roommate: 0,
      first_hand: 0,
      sublease: 0,
      location: '',
      start: new Date(),
      end: new Date(),
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
    };
    this.baseUrl = "http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/houses?";
    this.button_handler = this.button_handler.bind(this);
    this.startdateChange = this.startdateChange.bind(this);
    this.enddateChange = this.enddateChange.bind(this);
  }

  startdateChange(date) {
    this.setState({
      start: date
    }, () => { this.generate_query() });
  }

  enddateChange(date) {
    this.setState({
      end: date
    }, () => { this.generate_query() });
  }

  generate_query = () => {
    let url = this.baseUrl;
    if (this.state.location)
      url += `city=${this.state.location}`;
    if (this.state.roommate == 1) {
      url += "&type=roommate_needed";
      document.getElementById('3').style.backgroundColor = "#F7819F";
      document.getElementById('3').style.color = "white";
    } else {
      document.getElementById('3').style.backgroundColor = "#f3cbe8";
      document.getElementById('3').style.color = "white";
    }
    if (this.state.sublease == 1) {
      url += "&type=sublease";
      document.getElementById('1').style.backgroundColor = "#F7819F";
      document.getElementById('1').style.color = "white";
    } else {
      document.getElementById('1').style.backgroundColor = "#f3cbe8";
      document.getElementById('1').style.color = "white";
    }
    if (this.state.first_hand == 1) {
      url += "&type=first_hand";
      document.getElementById('2').style.backgroundColor = "#F7819F";
      document.getElementById('2').style.color = "white";
    } else {
      document.getElementById('2').style.backgroundColor = "#f3cbe8";
      document.getElementById('2').style.color = "white";
    }
    url += "&start_Date=" + moment(this.state.start).format('YYYY/MM/DD');
    url += "&end_Date=" + moment(this.state.end).format('YYYY/MM/DD');
    axios.get(url).then((response) => {
      this.setState({ houses: response.data.data });
      this.generate_markers();
    }).catch((error) => {
      console.log(error);
    });
  }

  componentWillReceiveProps(nextProps) {
    const values = queryString.parse(nextProps.location.search);
    this.setState({
      location: values.location,
      start: values.start,
      end: values.end,
      type: values.type
    }, () => { this.generate_query() });
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search)
    this.setState({
      location: values.location,
      start: values.start,
      end: values.end,
      type: values.type
    }, () => { this.generate_query() });
  }


  push_history = () => {
    let url = '/house?location=';
    if (this.state.location)
      url += `${this.state.location}`;
    if (this.state.roommate == 1)
      url += "&type=roommate_needed";
    else if (this.state.sublease == 1) {
      url += "&type=sublease";
    } else {
      url += "&type=first_hand";
    }
    url += "&start=" + moment(this.state.start).format('YYYY/MM/DD');
    url += "&end=" + moment(this.state.end).format('YYYY/MM/DD');
    history.push(url);
  }

  button_handler(id) {
    if (id == 1) {
      this.setState((state) => { return { sublease: 1 - state.sublease, first_hand: 0, roommate_needed: 0 } }, () => { this.push_history() });
      this.setState({ first_hand: 0 });
      this.setState({ roommate_needed: 0 });
    }
    else if (id == 2) {
      this.setState((state) => { return { first_hand: 1 - state.first_hand, sublease: 0, roommate_needed: 0 } }, () => { this.push_history() });
      this.setState({ sublease: 0 });
      this.setState({ roommate_needed: 0 });
    }
    else {
      this.setState((state) => { return { roommate: 1 - state.roommate, first_hand: 0, sublease: 0 } }, () => { this.push_history() });
    }

  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props.location,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  generate_markers = () => {
    let res = [];
    let data = this.state.houses;
    let c = { lat: 0, lng: 0 };
    for (let i = 0; i < data.length; i++) {
      c.lat += data[i].latitude;
      c.lng += data[i].longitude;
      res.push({ id: data[i]._id, lat: data[i].latitude, lng: data[i].longitude, type: data[i].type, cost: data[i].cost, address: data[i].address, photo: data[i].photo[0] });
    }
    this.setState({ places: res });
    c.lat /= data.length;
    c.lng /= data.length;
    this.setState({ center: c });
  }

  generate_houses = () => {
    let res = [];
    let data = this.state.houses;
    for (let i = 0; i < data.length; i++) {
      res.push(
        <Link to={{
          pathname: `/detail/${data[i]._id}`,
        }}>
          <Segment className="house_card">
            <Item.Group>
              <Item>
                <Item.Image className="card_image" src={data[i].photo[0]} />
                <Item.Content className="card_container">
                  <div>
                    <div className="part_1">
                      <Item.Meta content={data[i].city + "·" + data[i].state} />
                      <Item.Header className="abc">{data[i].address}</Item.Header>
                      <Item.Extra>
                        <Label>{data[i].type}</Label>
                      </Item.Extra>
                    </div>
                    <div className="part_2">
                      {"$" + data[i].cost}
                      <p className="cost-unit">/MON</p>
                    </div>
                  </div>
                  <Item.Description className="card_des">{"\"" + data[i].description + "\""}</Item.Description>
                </Item.Content>
              </Item>
            </Item.Group>
          </Segment>
        </Link>
      );
    }
    return res;
  }


  render() {
    return (
      <div className="house_container">
        <div className="house_card_container">
          <div className="query-button">
            <DatePicker selected={this.state.startDate} onChange={this.startdateChange} customInput={<Button>CHECK-IN</Button>} />
            <DatePicker selected={this.state.endDate} onChange={this.enddateChange} customInput={<Button>CHECKOUT</Button>} />
            <Button id='1' onClick={() => this.button_handler(1)}>SUBLEASE</Button>
            <Button id='2' onClick={() => this.button_handler(2)}>FIRST HAND</Button>
            <Button id='3' onClick={() => this.button_handler(3)}>ROOMMATE NEEDED</Button>
          </div>
          <div>
            <div className="house_card_container_inner">
              {this.generate_houses()}
            </div>
          </div>
        </div>
        <div className="map">
          <Map google={this.props.google} zoom={14} style={mapStyle} initialCenter={this.state.center} center={this.state.center}>
            {this.state.places.map(place => {
              let colors = {
                "sublease": "https://img.icons8.com/ios/50/000000/marker-filled.png",
                "first_hand": "https://img.icons8.com/cotton/64/000000/place-marker.png"
              }
              return (
                <Marker icon={{ url: colors[place.type] }} location={place} onClick={this.onMarkerClick} position={{ lat: place.lat, lng: place.lng }} />
              );
            })}
            <InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow}>
              {/* <Link to={'/detail/' + this.state.selectedPlace.id}> */}
                <div className="window">
                  <img id="window_image" src={this.state.selectedPlace.photo} />
                  <h1>{this.state.selectedPlace.address}</h1>
                  <h1>${this.state.selectedPlace.cost}/MONTH</h1>
                </div>
              {/* </Link> */}
            </InfoWindow>
          </Map>
        </div>
      </div>
    );
  }
}


export default GoogleApiWrapper({
  apiKey: 'AIzaSyC5S4FIkwJGSLu9FfqIn-hNUJq79mGZRig'
})(House);
